import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    type: String
  }

  static targets = ["webhookableId", "webhookableType"]

  connect() {
    // Load initial targets if type is set
    if (this.typeValue) {
      this.loadWebhookableTargets()
    }

    // Add change event listener to webhookable type select
    if (this.hasWebhookableTypeTarget) {
      this.webhookableTypeTarget.addEventListener("change", this.handleTypeChange.bind(this))
    }
  }

  disconnect() {
    // Clean up event listener
    if (this.hasWebhookableTypeTarget) {
      this.webhookableTypeTarget.removeEventListener("change", this.handleTypeChange.bind(this))
    }
  }

  handleTypeChange(event) {
    this.typeValue = event.target.value
    this.loadWebhookableTargets()
  }

  typeValueChanged() {
    // This will be called when typeValue is updated programmatically
    this.loadWebhookableTargets()
  }

  async loadWebhookableTargets() {
    const type = this.typeValue
    if (!type) return

    try {
      const response = await fetch(`/webhooks/targets?type=${type}`)
      const data = await response.json()

      const select = this.webhookableIdTarget
      select.innerHTML = '<option value="">Select a target...</option>'

      data.forEach(item => {
        const option = document.createElement('option')
        option.value = item.id
        option.textContent = item.name
        select.appendChild(option)
      })
    } catch (error) {
      console.error('Error loading webhookable targets:', error)
    }
  }
}
